import { DictionaryBalanceUnitAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useDictionaryBalanceUnits() {
  return useAutocompleteSource<DictionaryBalanceUnitAutocomplete>({
    url: EvidenceAPI.DICTIONARY_BALANCE_UNITS + '/autocomplete',
  });
}
